import React, { useContext } from "react";
import Timeline from "features/signals/SignalDrawer/Timeline/Timeline";
import Flex from "common/Boxes/Flex";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import { SignalDetailsContext } from "@shared/features/signals/common/SignalDetails.context";
import SignalChart from "features/signals/SignalDrawer/SignalChart";
import useMedia from "utils/hooks/useMedia";
import { SMALL_SCREEN } from "common/constants";

const TimelinePage = ({ exchanges, symbol }) => {
  const { generalDataQuery, getSignalExtraInfoActivitiesQuery } =
    useContext(SignalDetailsContext)!;
  const isSmallScreen = useMedia(
    [`(max-width: ${SMALL_SCREEN})`],
    [true],
    false
  );

  const isLoading =
    generalDataQuery.isLoading ||
    getSignalExtraInfoActivitiesQuery.isLoading ||
    getSignalExtraInfoActivitiesQuery.isUninitialized;

  return (
    <LoadingSpinnerOverlay
      isLoading={isLoading}
      spinnerMarginTop={50}
      hideContentWhileLoading={true}
    >
      <Flex $flexDirection="column" $alignItems="center">
        {isSmallScreen && <SignalChart symbol={symbol} exchanges={exchanges} />}
        <Timeline />
      </Flex>
    </LoadingSpinnerOverlay>
  );
};

export default TimelinePage;
